import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Tooltip,
} from "@material-ui/core"
import {
  urlGetStatusJKN,
  urlUpdateWaktuAntrean,
} from "App/Component/layout/Registrasi/BookingAntrian/ui"
import ModalDetailJkn from "App/Component/layout/Registrasi/BookingAntrian/ui/ModalDetailJkn"
import { InputTextArea, MasterButton, Modal } from "App/Component/ui"
import { instanceWsBPJS } from "App/constants"
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers"
import React, { useState } from "react"
import { itSelfEmpty } from "utils/all"

export default function ModalStatusResponse({
  openStatus,
  data,
  withButtonDelete = false,
}) {
  const [formKeteranganBatal, setFormKeteranganBatal] = useState("")
  const [openDelete, setOpenDelete] = useState()
  const [showModalDetailJKN, setShowModalDetailJKN] = useState(false)
  const [loadingJKN, setLoadingJKN] = useState(false)
  const [dataJKN, setDataJKN] = useState()
  const kode_booking = data?.request?.kode_booking??""

  const [formData, setFormData] = useState({
    id: null,
    keterangan_batal_jkn: "",
  }) // dummyState

  const confirmDelete = async () => {
    const defaultMessageError = "Terjadi kesalahan saat membatalkan booking JKN"
    try {
      if (isNull(kode_booking)) {
        return defaultToastError("Kode Booking Tidak Boleh Kosong !")
      }
      const payload = {
        kode_booking: kode_booking,
        Keterangan: formKeteranganBatal,
      }
      const response = await instanceWsBPJS.post(urlUpdateWaktuAntrean, payload)
      const statusCode = response.data?.metadata?.code
      const message = response.data?.metadata?.message

      if (parseInt(statusCode) === 200) {
        defaultToastSuccess(message ?? "Sukses")
      } else {
        defaultToastError(message ?? defaultMessageError)
      }
    } catch (error) {
      defaultToastError(defaultMessageError)
      console.log(defaultMessageError.toUpperCase() + error)
    }
  }

  const fetchStatusJkn = async () => {
    const kode_booking_jkn =
      typeof kodeBooking === "number" ? kode_booking.toString() : kode_booking

    return instanceWsBPJS.post(urlGetStatusJKN, {
      kode_booking: kode_booking_jkn,
    })
  }

  const handleClickStatusJKN = async () => {
    setShowModalDetailJKN(true)
    setDataJKN()
    try {
      setLoadingJKN(true)
      const response = await fetchStatusJkn()
      const data = response.data?.response?.list
      setDataJKN(data)
    } catch (error) {
      defaultToastError("Terjadi Kesalahan saat mengambil data JKN")
      console.log("GAGAL MENDAPATKAN DATA JKN: ", error)
    } finally {
      setLoadingJKN(false)
    }
  }

  return (
    <>
      <Modal title="Detail Status" show={openStatus} width="60%">
        {showModalDetailJKN && (
          <ModalDetailJkn
            setShowModal={setShowModalDetailJKN}
            formData={formData}
            dataJKN={dataJKN}
            loadingJKN={loadingJKN}
            setFormData={setFormData}
            withButtonDelete={false}
          />
        )}
        <Dialog
          open={openDelete}
          onClose={() => {
            setOpenDelete(false)
          }}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            Konfirmasi Delete Booking {kode_booking}
          </DialogTitle>
          <DialogContent dividers>
            <InputTextArea
              label={"KETERANGAN"}
              placeholder={"Keterangan"}
              name="keterangan-batal"
              value={formKeteranganBatal}
              onChange={(e) => setFormKeteranganBatal(e.target.value)}
              id={"keterangan-batal-jkn"}
              rows={"3"}
            />
          </DialogContent>
          <DialogActions>
            <MasterButton
              name="Hapus"
              color="danger"
              type="button"
              onClick={() => confirmDelete()}
            />
          </DialogActions>
        </Dialog>
        <Grid container spacing={3}>
          <Grid item sm={6}>
            <InputTextArea
              id="request"
              label="Request"
              name="request"
              rows={25}
              value={JSON.stringify(itSelfEmpty(data?.request, {}), null, 2)}
            />
          </Grid>
          <Grid item sm={6}>
            <InputTextArea
              id="response"
              rows={25}
              label="response"
              name="response"
              value={JSON.stringify(itSelfEmpty(data?.response, {}), null, 2)}
            />
          </Grid>
        </Grid>
        {withButtonDelete && (
          <>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              spacing={1}
            >
              <div style={{ display: "flex", gap: "5px" }}>
                <Tooltip title="Batal booking JKN">
                  <span>
                    <MasterButton
                      type={"button"}
                      className={"mt-1"}
                      color={"danger"}
                      name={"BATAL BOOKING"}
                      outline
                      onClick={() => {
                        setOpenDelete(true)
                      }}
                      size="md"
                    />
                  </span>
                </Tooltip>
                <Tooltip title={"Lihat Status JKN"} aria-label="delete">
                  <span>
                    <MasterButton
                      type={"button"}
                      color={"warning"}
                      className={"mt-1"}
                      name={"STATUS JKN"}
                      outline
                      onClick={(e) => handleClickStatusJKN(e)}
                      size="md"
                    />
                  </span>
                </Tooltip>
              </div>
            </Grid>
          </>
        )}
      </Modal>
    </>
  )
}
